import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/motion";

const SUBSTACK = "https://oceantooasis.substack.com";

export const Newsletter = () => {
    const [email, setEmail] = useState("");

    const subscribe = (e) => {
        e.preventDefault();
        const url = email
            ? `${SUBSTACK}/subscribe?email=${encodeURIComponent(email)}`
            : `${SUBSTACK}/subscribe`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <section
            data-testid="newsletter-section"
            className="relative py-20 md:py-28 px-6 md:px-10 bg-lavender"
        >
            <Reveal className="max-w-7xl mx-auto">
                <div className="rounded-3xl bg-white/60 backdrop-blur-xl border border-white/70 shadow-[0_20px_60px_rgba(15,42,68,0.08)] p-8 md:p-12 grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-8 lg:gap-12 items-center">
                    <div>
                        <span className="section-label">
                            The Salinity Report
                        </span>
                        <h2 className="mt-4 font-display font-black text-ocean text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
                            Thoughts on desalination, from the people building
                            it.
                        </h2>
                        <p className="mt-4 text-inkblue text-sm md:text-base leading-relaxed">
                            Occasional essays on water, energy and the road to
                            abundance. No spam, unsubscribe anytime.
                        </p>
                    </div>

                    <form
                        onSubmit={subscribe}
                        data-testid="newsletter-form"
                        className="w-full"
                    >
                        <div className="flex flex-col sm:flex-row gap-3">
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@company.com"
                                data-testid="newsletter-email-input"
                                className="flex-1 px-5 py-4 rounded-full bg-white border border-ocean/15 text-ocean placeholder:text-inkblue/50 text-sm focus:outline-none focus:ring-2 focus:ring-teal/40 transition"
                            />
                            <button
                                type="submit"
                                data-testid="newsletter-subscribe-btn"
                                className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-ocean text-white font-bold text-sm hover:bg-ocean-mid transition-all duration-300 shadow-[0_8px_28px_rgba(15,42,68,0.2)] hover:-translate-y-0.5"
                            >
                                Subscribe
                                <ArrowUpRight
                                    size={16}
                                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                />
                            </button>
                        </div>
                    </form>
                </div>
            </Reveal>
        </section>
    );
};

export default Newsletter;
